import React from 'react';
import { useTranslation } from 'react-i18next';
import Search from '@jwp/ott-theme/assets/icons/search.svg?react';
import SearchSmall from '@jwp/ott-theme/assets/icons/Search-small.svg?react';
import CloseIcon from '@jwp/ott-theme/assets/icons/close.svg?react';
import classNames from 'classnames';
import IconButton from '../IconButton/IconButton';
import Icon from '../Icon/Icon';

import styles from './SearchBar.module.scss';

export type Props = {
  query?: string;
  onQueryChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClearButtonClick?: () => void;
  onClose?: () => void;
  inputRef?: React.MutableRefObject<HTMLInputElement>;
  placeholder?: boolean;
  className?: string;
  containerClassName?: string;
  variant?: 'default' | 'compact';
};

const SearchBar: React.FC<Props> = ({
  query,
  onQueryChange,
  onClose,
  inputRef,
  placeholder,
  className,
  containerClassName,
  variant = 'default'
}: Props) => {
  const { t } = useTranslation('search');
  const handleSubmit = (event: React.ChangeEvent<HTMLFormElement>) => {
    event.preventDefault();
    inputRef?.current.focus(); // Force hide mobile keyboard
    (document.querySelector('#content') as HTMLElement)?.focus();
  };

  return (
    <div className={classNames(styles.searchBar, styles[variant], containerClassName)}>
      {variant == 'compact' ? <Icon icon={SearchSmall} className={styles.iconSmall} /> : <Icon icon={Search} className={styles.icon} />}
      <form className={classNames(styles.searchForm, className)} role="search" onSubmit={handleSubmit}>
        <label htmlFor="searchbar-input" className="hidden">
          {t('search_bar.search_label')}
        </label>
        <input
          className={styles.input}
          id="searchbar-input"
          type="text"
          value={query}
          onChange={onQueryChange}
          onKeyDown={(event) => event.key === 'Escape' && onClose?.()}
          placeholder={placeholder ? t('search_bar.search_placeholders') : t('search_bar.search_placeholder')}
          ref={inputRef}
        />
      </form>
      <IconButton onClick={onClose} className={styles.clearButton} aria-label={t('search_bar.clear_label')}>
        <Icon icon={CloseIcon} />
      </IconButton>
    </div>
  );
};
export default SearchBar;
